import {
	CHIP_THEME,
	COLOR,
	Chips as ChipsV2,
} from '@dealstack/frontend/shared/components/Chips/Chips.v2';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';

import { ForIndividuals } from './ForIndividuals';

interface Props {
	className?: string;
}

const ForVehicles = ({ className }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<div className={className}>
			<ForIndividuals />
			<SectionHeader
				size="p-lgb"
				title={tMipCreate('schedule.vehicles_section.personal_data_requirements.title')}
				subtitle={tMipCreate(
					'schedule.vehicles_section.personal_data_requirements.subtitle'
				)}
			/>
			<ChipsWrapper>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(
						`schedule.vehicles_section.personal_data_requirements.name_of_investment_vehicle`
					)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(
						`schedule.vehicles_section.personal_data_requirements.corporate_registration_number`
					)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(`schedule.vehicles_section.personal_data_requirements.address`)}
				</ChipsV2>
				<ChipsV2
					prefixIcon="checkmark-circle-contained-filled"
					size="s"
					color={COLOR.GREEN}
					chipTheme={CHIP_THEME.LIGHT}
				>
					{tMipCreate(
						`schedule.vehicles_section.personal_data_requirements.legal_representative`
					)}
				</ChipsV2>
			</ChipsWrapper>
		</div>
	);
};

const ChipsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin: 1em 0;
	gap: 0.5em;
`;

const Memoized = memo(ForVehicles);
const Styled = styled(Memoized)`
	${SectionHeader} {
		margin-top: 1.5em;
	}
`;

export { Styled as ForVehicles };
